<template>
  <div>
    <input
      @change="$emit('checkboxValue', checked)"
      type="checkbox"
      :id="setId"
      v-model="checked"/>
    <label :for="setId">{{labelValue}}</label>

  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  data() {
    return {
      checked: this.initialValue,
    };
  },
  props: {
    initialValue: Boolean,
    id: String,
    label: String,
  },
  watch: {
    initialValue() {
      this.checked = this.initialValue;
    },
  },
  computed: {
    labelValue() {
      if (this.label) {
        return this.I18n.t(this.label);
      }
      return null;
    },
    setId() {
      return this.id ? this.id : 'checkbox';
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/checkbox.vue?32b51514